import React from "react";

const DescriptionList = ({ data }) => {
  return (
    <div className="payableStatic">
      <span className="title-1">修改结果：</span>
      <div className="group-1">
        <span className="group-1">
          转违约金<span className="num">{data.damages || 0}</span>
        </span>
        <span className="group-1">
          退回<span className="num">{data.refund || 0}</span>
        </span>
        <span className="group-1">
          作废<span className="num">{data.obsolete || 0}</span>
        </span>
      </div>
    </div>
  );
};

export default DescriptionList;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/end/PayableStatic.js